const config = [
    {
        component: 'ZlmTitle',
        options: {
            size: 'medium',
            text: '基本信息',
        },
    },
    {
        component: 'ZlmNormalDetail',
        options: {
            data: {},
        },
    },
    {
        component: 'ZlmTitle',
        options: {
            size: 'medium',
            text: '通知书',
        },
    },
    {
        component: 'ZlmNormalDetailList',
        options: {
            data: {},
        },
    },
    // 后端说暂时没有返回这部分数据
    // {
    //     component: 'ZlmTitle',
    //     options: {
    //         size: 'medium',
    //         text: '审核记录',
    //     },
    // },
    // {
    //     component: 'ZlmTabDetail',
    //     options: {
    //         title: '记录',
    //         data: [],
    //     },
    // },
]

const { getProjectTypeName } = require('../projectType')
const { getPurchaseTypeName } = require('../purchaseType')

const mixin = {
    data() {
        return {
            config: JSON.parse(JSON.stringify(config)),
        }
    },
    methods: {
        getData() {
            this.$request.post(`/transformToAfter/app/track/dbOverview`, {
                bdGuid: this.$route.query.id,
                ggBdGuid: this.$route.query.ggBDGuid,
            }, { showLoading: true }).then((res) => {
                this.getZbtzsDetail(res.data)
            })
        },
        getZbtzsDetail(row) {
            this.$request.post(`/transformToAfter/app/determine/bid/tzsInfoView`, {
                bdGuid: this.$route.query.id,
                guid: row.dbZhongBiaoJieGuoTongZhiGuid,
            }).then((res) => {
                console.log(res)
                if (res.data && res.data.rows) {
                    const rows = res.data.rows
                    this.config[1].options.data = {
                        '标段名称': rows.bdName,
                        '标段编号': rows.bdBH,
                        '项目类型': getProjectTypeName(rows.zbxmlx),
                        '采购方式': getPurchaseTypeName(rows.cgFangShi),
                        '供应商总数': rows.gysCount,
                        '中标供应商': rows.zbgysCount,
                    }
                    if (rows.zbTongZhiShufwfListVO && rows.zbTongZhiShufwfListVO.length > 0) {
                        this.config[3].options.data = rows.zbTongZhiShufwfListVO.map((t) => ({
                            '中标供应商': t.tbrName,
                            '中标金额(元)': t.zhongBiaoJia,
                            '代理服务费金额(元)': t.zbdlFuWuFei,
                        }))
                        console.log(this.config[3].options.data)
                    }
                }
            })
        },
    },
}

module.exports = {
    config,
    mixin,
}
